var React = require('react');

function IceCream (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M367.94,256.19H80.06a48,48,0,0,1-4.16-95.92c1.39-.06,2.77-.06,4.16,0H81a143.94,143.94,0,1,1,286,0h.94a48,48,0,0,1,4.16,95.92c-1.39.06-2.77.06-4.16,0Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M195.39,493.69,96.05,288.17H352L252.61,493.69a31.52,31.52,0,0,1-57.22,0Z","className":"fa-primary","key":2})]);
}

IceCream.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = IceCream;

IceCream.default = IceCream;
